import React, {PureComponent} from 'react';
import {Route} from 'react-router-dom';

import {matchUrlInRouteConfigs} from '../../core/route/routeUtils';

const renderMergedProps = ({component, routeProps, routingProps}) => {

  const finalProps = {
    ...routeProps,
    ...routingProps,
    initialMatch: matchUrlInRouteConfigs(routingProps?.url, routingProps?.platform),
  };

  return React.createElement(component, finalProps);
};

/* eslint-disable react/jsx-no-bind */
class HbRoute extends PureComponent {
  render() {
    const {component, routingProps, ...rest} = this.props;

    return (
      <Route
        {...rest}
        render={(routeProps) => renderMergedProps({component, routeProps, routingProps})}/>
    );
  }
}
/* eslint-enable react/jsx-no-bind */

export default HbRoute;
